import request from '@/utils/request'

export function getJsConfig(params) {
  return request({
    url: '/oa/get_js',
    method: 'get',
    params
  })
}

export function getRetUrl(params) {
  return request({
    url: '/oa/ret_url',
    method: 'get',
    params
  })
}

export function getCaptcha(params) {
  return request({
    url: '/captcha/get',
    method: 'get',
    params
  })
}

export function checkCaptcha(params) {
  return request({
    url: '/captcha/check',
    method: 'get',
    params
  })
}

export function bind(data) {
  return request({
    url: '/agent/bind',
    method: 'post',
    data
  })
}

export function login(params) {
  return request({
    url: '/agent/login',
    method: 'get',
    params
  })
}

export function loginByAlipay(params) {
  return request({
    url: '/agent/loginbyali',
    method: 'get',
    params
  })
}

export function agreeLogin(params) {
  return request({
    url: '/agent/scancode_login',
    method: 'get',
    params
  })
}

export function getInfo(token) {
  return request({
    url: '/agent/info',
    method: 'get',
    params: {
      token
    }
  })
}

export function saveBank(data) {
  return request({
    url: '/agent/save_bank_info',
    method: 'post',
    data
  })
}

export function unBind() {
  return request({
    url: '/agent/un_bind',
    method: 'get'
  })
}


// WEBPACK FOOTER //
// ./src/api/user.js